import {ThemeMode} from "interfaces";

export function toggleBodyTheme(theme: ThemeMode): void {
  theme === "dark"
    ? document.body.classList.add("dark")
    : document.body.classList.remove("dark");
}
